import React from 'react';
import { XIcon } from 'lucide-react';
export function WhyDietsFailSection() {
  const reasons = ['Às vezes, é retenção.', 'Às vezes, é gases.', 'Às vezes, é intestino preso.', 'Às vezes, é excesso de sal.', 'Às vezes, são ultraprocessados.', 'Às vezes, são combinações alimentares que deixam seu corpo pesado.'];
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-279">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-280">
        <div className="text-center mb-12" data-id="element-281">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-6" data-id="element-282">
            Por Que O Que Você Tentou Antes Não Funcionou?
          </h2>
          <p className="text-lg text-brand-text/80 leading-relaxed max-w-3xl mx-auto" data-id="element-283">
            Porque a maioria das dietas trata toda barriga como se fosse
            gordura. Mas nem toda barriga aumentada é gordura.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-12" data-id="element-284">
          {reasons.map((reason, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-sage/20 flex items-center" data-id="element-285">
              <div className="bg-brand-pink/50 p-2 rounded-full mr-4 flex-shrink-0" data-id="element-286">
                <XIcon className="w-5 h-5 text-brand-dark" data-id="element-287" />
              </div>
              <p className="text-brand-text font-medium" data-id="element-288">{reason}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-289">
          <p className="text-xl font-serif font-medium text-brand-dark" data-id="element-290">
            O Desincha40+ quebra esse ciclo sem terrorismo alimentar, sem
            promessa mágica e sem cardápio impossível.
          </p>
        </div>
      </div>
    </section>;
}